import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=701eb1b8&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=701eb1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701eb1b8",
  null
  
)

export default component.exports